import _ from "lodash";
import { getPageArray } from "../../../components/editor/ai2/getPageArray";
import { getChangeHistoryItem } from "./getChangeHistoryItem";
import { setChangeHistoryData } from "../actions";
import {
  saveWebsiteFooterInState,
  saveWebsiteNavInState,
  toggleWebsiteFooterEditionsDetected,
  toggleWebsiteNavEditionsDetected,
} from "../../websites/actions";
import {
  changeWebsitePageComponentContent,
  toggleNewWebsitePageEditionsDetected,
} from "../../websitePages/actions";
import { HandleUndo } from "../types";

export const handleUndo: HandleUndo = ({
  componentId,
  currentWebsitePage,
  currentWebsite,
  currentPageIndex,
}) => {
  return (dispatch) => {
    const changeHistoryItem = dispatch(getChangeHistoryItem(componentId));
    if (
      changeHistoryItem.availableAction !== "undo" ||
      _.isEmpty(changeHistoryItem.before)
    )
      return;
    const pageArray = getPageArray(currentWebsitePage, currentWebsite);
    const component = pageArray.find((pageComponent) => {
      return pageComponent.id === componentId;
    });
    const componentIndex = pageArray.indexOf(component) - 1;
    dispatch(
      setChangeHistoryData({
        componentId,
        after: component.componentData,
        availableAction: "redo",
      })
    );
    if (component.id === "navigation") {
      dispatch(
        saveWebsiteNavInState({
          navObject: {
            ...currentWebsite.nav,
            componentData: _.cloneDeep(changeHistoryItem.before),
          },
          currentWebsiteSubdomain: currentWebsite.subdomain,
        })
      );
      dispatch(toggleWebsiteNavEditionsDetected(true));
    }
    if (component.id === "footer") {
      dispatch(
        saveWebsiteFooterInState({
          footerObject: {
            ...currentWebsite.footer,
            componentData: _.cloneDeep(changeHistoryItem.before),
          },
          currentWebsiteSubdomain: currentWebsite.subdomain,
        })
      );
      dispatch(toggleWebsiteFooterEditionsDetected(true));
    }
    if (component.id !== "navigation" && component.id !== "footer") {
      dispatch(
        changeWebsitePageComponentContent({
          currentPageIndex,
          componentKey: componentIndex,
          componentData: _.cloneDeep(changeHistoryItem.before),
        })
      );
      dispatch(toggleNewWebsitePageEditionsDetected(true));
    }
  };
};
